import { ExportFile } from '../types/export/export';
import {
  ProductExportConfiguration,
  CreateProductExportConfigurationInput,
  UpdateProductExportConfigurationInput,
  DeleteProductExportConfigurationInput,
} from '../types/product_export_configuration';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const EXPORT = '/api/product/export';
const CONFIGURATIONS = '/api/product/export/list';
const CREATE_CONFIGURATION = '/api/product/export/create';
const UPDATE_CONFIGURATION = '/api/product/export/update';
const DELETE_CONFIGURATION = '/api/product/export/delete';

export namespace ProductExportConfigurationRequest {
  export interface ProductExportPayload {
    configId?: string;
    timezone?: string;
    locale?: string;
    date?: Date;
    binId?: string;
    includeNoStock?: boolean;
  }

  export const download = async (payload: ProductExportPayload): Promise<ExportFile> => {
    return (await http.post(EXPORT, payload)).data;
  };

  export const list = async (payload: { page: number }): Promise<PaginatedResponse<ProductExportConfiguration>> => {
    return (await http.post(CONFIGURATIONS, payload)).data;
  };

  export const create = async (payload: {
    data: CreateProductExportConfigurationInput[];
  }): Promise<ProductExportConfiguration[]> => {
    return (await http.post(CREATE_CONFIGURATION, payload)).data;
  };

  export const update = async (payload: {
    data: UpdateProductExportConfigurationInput[];
  }): Promise<ProductExportConfiguration[]> => {
    return (await http.post(UPDATE_CONFIGURATION, payload)).data;
  };

  export const remove = async (payload: {
    data: DeleteProductExportConfigurationInput[];
  }): Promise<ProductExportConfiguration[]> => {
    return (await http.post(DELETE_CONFIGURATION, payload)).data;
  };
}
